// Shared Leaflet icons + operator palette for the Prospección map.
// Kept at module level (never re-created) to prevent marker jitter on re-renders.
import L from 'leaflet';

export const OP_COLORS = {
  ORANGE: '#ff6b00',
  WILLIAM_VDF: '#e60000',
  WILLIAM_OSP: '#3b82f6',
  AVE_OSP: '#10b981',
  AVE_OTROS: '#22c55e',
  _default: '#A3FF12',
};

const _makeIcon = (c) => L.divIcon({
  className: 'sf-node-icon',
  html: `<div style="width:14px;height:14px;border-radius:50%;background:${c};border:2px solid #fff;box-shadow:0 0 6px ${c}cc"></div>`,
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});
const NODE_ICONS = Object.fromEntries(Object.entries(OP_COLORS).map(([k, c]) => [k, _makeIcon(c)]));
export const nodeIcon = (op) => NODE_ICONS[op] || NODE_ICONS._default;

// Red dot – comm towers picked up via OSM query
export const towerIcon = L.divIcon({
  className: '',
  html: '<div style="width:14px;height:14px;border-radius:50%;background:#ff3b30;border:2px solid #fff;box-shadow:0 0 8px rgba(255,59,48,0.7)"></div>',
  iconSize: [14, 14],
  iconAnchor: [7, 7],
});

// Purple square – protected buildings
export const protectedIcon = L.divIcon({
  className: '',
  html: '<div style="width:16px;height:16px;border-radius:4px;background:#a855f7;border:2px solid #fff;box-shadow:0 0 8px rgba(168,85,247,0.85)"></div>',
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

// Purple diamond – physical Totem towers
export const towerTotemIcon = L.divIcon({
  className: 'sf-tower-icon',
  html: '<div style="width:16px;height:16px;background:#a855f7;border:2px solid #fff;box-shadow:0 0 8px rgba(168,85,247,0.85);clip-path:polygon(50% 0%,100% 50%,50% 100%,0% 50%)"></div>',
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

// GeoJSON coverage-zone style by quality
export const coverageStyle = (q) => ({
  baja: { color: '#ef4444', fillColor: '#ef4444', fillOpacity: 0.2, weight: 2 },
  media: { color: '#f59e0b', fillColor: '#f59e0b', fillOpacity: 0.18, weight: 2 },
  alta: { color: '#A3FF12', fillColor: '#A3FF12', fillOpacity: 0.12, weight: 2 },
}[q] || { color: '#fff', fillOpacity: 0.1 });

export const streetViewUrl = (lat, lng) => `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`;
export const googleMapsUrl = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;
